import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function ExpandLessIcon(props: SvgIconProps): JSX.Element {
  const defaultColor = 'primary';
  const color = props.color || defaultColor;
  return (
    <SvgIcon
      {...props}
      color={color}
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 24 24"
      xmlSpace="preserve"
      enableBackground="new 0 0 24 24"
      titleAccess="ExapandLess"
      fill="none"
      fontSize={'small'}
    >
      <path
        d="M20 16L12 8L4 16"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ fill: 'none' }}
      />
    </SvgIcon>
  );
}
